import NP from 'number-precision';

/**
 * 千分位格式化
 * @param {数字} num
 */
export function toThousands(num) {
  let val = num.toString();

  if (!val.includes('.')) {
    val += '.';
  }
  return val.replace(/(\d)(?=(\d{3})+\.)/g, ($0, $1) => `${$1},`).replace(/\.$/, '');
}


/**
 * 阿拉伯数组转中文数字
 * @param {number} money 金额
 *
 */
/* eslint-disable prefer-destructuring */
export function convertCurrency(money = '') {
  const maxNum = 999999999999999.9999; // 最大处理的数字

  if (money === '') {
    return '';
  }
  if (money >= maxNum) {
    // 超出最大处理数字
    return '';
  }

  const cnNums = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
  const cnIntRadice = ['', '拾', '佰', '仟'];
  const cnIntUnits = ['', '万', '亿', '兆']; // 对应整数部分扩展单位
  const cnDecUnits = ['角', '分', '毫', '厘']; // 对应小数部分单位
  const cnInteger = '整'; // 整数金额时后面跟的字符
  const cnIntLast = '元'; // 整型完以后的单位
  let integerNum; // 金额整数部分
  let decimalNum; // 金额小数部分
  let chineseStr = ''; // 输出的中文金额字符串
  let parts; // 分离金额后用的数组，预定义
  money = parseFloat(money);

  if (money === 0) {
    chineseStr = cnNums[0] + cnIntLast + cnInteger;
    return chineseStr;
  }
  // 转换为字符串
  money = money.toString();
  if (money.indexOf('.') === -1) {
    integerNum = money;
    decimalNum = '';
  } else {
    parts = money.split('.');
    integerNum = parts[0];
    decimalNum = parts[1].substr(0, 4);
  }
  // 获取整型部分转换
  if (parseInt(integerNum, 10) > 0) {
    let zeroCount = 0;
    const intLen = integerNum.length;
    for (let i = 0; i < intLen; i += 1) {
      const n = integerNum.substr(i, 1);
      const p = intLen - i - 1;
      const q = p / 4;
      const m = p % 4;
      if (n === '0') {
        zeroCount += 1;
      } else {
        if (zeroCount > 0) {
          chineseStr += cnNums[0];
        }
        // 归零
        zeroCount = 0;
        chineseStr += cnNums[parseInt(n, 10)] + cnIntRadice[m];
      }
      if (m === 0 && zeroCount < 4) {
        chineseStr += cnIntUnits[q];
      }
    }
    chineseStr += cnIntLast;
  }
  // 小数部分
  if (decimalNum !== '') {
    const decLen = decimalNum.length;
    for (let i = 0; i < decLen; i += 1) {
      const dn = decimalNum.substr(i, 1);
      if (dn !== '0') {
        chineseStr += cnNums[Number(dn)] + cnDecUnits[i];
      }
    }
  }
  if (chineseStr === '') {
    chineseStr += cnNums[0] + cnIntLast + cnInteger;
  } else if (decimalNum === '') {
    chineseStr += cnInteger;
  }
  return chineseStr;
}


/**
 * 格式化小数位
 *
 * @export
 * @param {*} val 小数
 * @param {number} [pos=2] 保留的小数位
 * @returns
 */
/* eslint-disable no-restricted-properties */
export function formatFloat(val, pos = 2) {
  let f = parseFloat(val);
  if (Number.isNaN(f)) {
    return '0.00';
  }
  f = Math.round(val * Math.pow(10, pos)) / Math.pow(10, pos); // pow 幂
  let s = f.toString();
  let rs = s.indexOf('.');
  if (rs < 0) {
    rs = s.length;
    s += '.';
  }
  while (s.length <= rs + pos) {
    s += '0';
  }
  return s;
}


/**
 * 数值进位加 1
 *
 * @export
 * @param {*} val
 * @param {number} [pos=2] 保留的小数位
 * @returns
 */
export function ceil(val, pos = 0) {
  if (!val) {
    return val;
  }

  const swell = Math.pow(10, pos);
  const swellVal = val * swell;
  const newVal = Math.ceil(swellVal) / swell;
  console.log(`${val} [${pos}] =>> ${newVal}`);

  return newVal;
}

export function floor(val, pos = 0) {
  if (!val) {
    return val;
  }

  const swell = Math.pow(10, pos);
  const swellVal = val * swell;
  return Math.floor(swellVal) / swell;
}

// 大额数值转换
export function formateNum(num, digits = 2) {
  if (Number.isNaN(num)) return 0;
  num = +num;
  if (num < 100000) {
    // 数字小于十万，按照99,999形式显示
    return num.toLocaleString();
  }
  let baseNum = 1;
  let unit = '';
  if (num < 100000000) {
    // 数字小于1亿，按照9999.99万这种形式显示
    baseNum = 10000;
    unit = '万';
  } else {
    // 如果数字大于等于亿
    baseNum = 100000000;
    unit = '亿';
  }
  const numArr = (num / baseNum).toFixed(digits).split('.'); // 四舍五入取小数点后两位
  const intBit = numArr[0];
  const decimalBit = numArr[1];

  return `${(+intBit).toLocaleString()}.${decimalBit}${unit}`;
}

/**
 * 分转元
*/
export const regFenToYuan = (number) => {
  return parseFloat(NP.divide(number, 100));
};

/**
 * 精度 元转分
 * arg1:要转换的钱，单位元； multiple: 转换倍数
*/
export const regYuanToFen = (arg1, multiple = 100) => {
  let m = 0;
  const s1 = arg1?.toString() || '';
  const s2 = multiple?.toString() || '';
  try { m += (s1.split('.')[1]?.length || 0); } catch (e) { console.error(e); }
  try { m += (s2.split('.')[1]?.length || 0); } catch (e) { console.error(e); }
  // eslint-disable-next-line no-mixed-operators
  return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m);
};


/**
 * 计算金额的位数
 * @param val
 * @returns
 */
export const getAmountUnit = (val, num = -1) => {
  if (val) {
    // eslint-disable-next-line radix
    const value = parseInt(val);
    if (typeof value === 'number') {
      const arr = ['个', '十', '百', '千', '万', '十万', '百万', '千万', '亿', '十亿', '百亿', '千亿'];
      if (value.toString().length > num) {
        if (value.toString().length > 12) {
          return arr[arr.length - 1];
        }
        return arr[value.toString().length - 1];
      }
    }
  }
  return '';
};
